import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { BaseDetailPageComponent } from '../../../../../components/pages/base-detail-page/base-detail-page.component';
import BaseDetailPageConfig from '../../../../../models/base-detail-page.config';
import { QualityManagementService } from '../../../../../services/quality-management.service';
import { RouteService } from '../../../../../services/route.service';
import { CommonService } from '../../../../../services/common.service';
import { MainLayoutService } from '../../../../../services/main-layout.service';
import { AccessControlService } from '../../../../../services/access-control.service';
import { RiskTimeFrame } from '../../../../../models/entities/risk';

@Component({
  selector: 'app-risk-time-frame-detail-page',
  imports: [BaseDetailPageComponent],
  templateUrl: './risk-time-frame-detail-page.component.html',
  styleUrl: './risk-time-frame-detail-page.component.scss'
})
export class RiskTimeFrameDetailPageComponent implements OnInit, OnDestroy {

  baseDetailPageConfig!: BaseDetailPageConfig;
  riskTimeFrame?: RiskTimeFrame;

  private destroy$ = new Subject<void>();

  constructor(
    private qualityManagementService: QualityManagementService,
    private routeService: RouteService,
    private commonService: CommonService,
    private mainLayoutService: MainLayoutService,
    private accessControlService: AccessControlService
  ) { }

  ngOnInit(): void {
    this.baseDetailPageConfig = {
      pageTitle: 'Risk Time Frame',
      cardTitle: 'Risk Time Frame Detail',
      dataList: {
        data: null,
        rows: [
          {
            attribute: 'code',
            label: 'Code',
            value: (item: any) => item?.code ?? '-'
          },
          {
            attribute: 'name',
            label: 'Name',
            value: (item: any) => item?.name ?? '-'
          },
          {
            attribute: 'createTime',
            label: 'Create Time',
            value: (item: any) => this.formatDate(item?.createTime)
          }
        ]
      },
      apiDetailService: (riskTimeFrameId: number) =>
        this.qualityManagementService.detailRiskTimeFrame(riskTimeFrameId),
      routeParamName: 'riskTimeFrameId',
      responseModelName: 'riskTimeFrame'
    };

    this.mainLayoutService.activeProfile$
      .pipe(takeUntil(this.destroy$))
      .subscribe(profileCode => {
        const canModify = this.accessControlService.hasFeatureActionAccess(
          profileCode,
          'QUALITY_MANAGEMENT_SETTINGS_RISK_TIME_FRAMES',
          'modify'
        );

        this.baseDetailPageConfig.editItemButton = canModify
          ? {
              type: 'success',
              title: 'Edit Time Frame',
              onClick: () => this.routeService.riskTimeFrameUpdate(
                Number(this.riskTimeFrame?.riskTimeFrameId)
              )
            }
          : undefined;
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  onLoadedDetail(data: RiskTimeFrame): void {
    this.riskTimeFrame = data;
  }

  private formatDate(value?: string | null): string {
    if (!value) {
      return '-';
    }

    const date = new Date(value);
    return isNaN(date.getTime()) ? '-' : this.commonService.formatDate(date);
  }
}
